$window = $(window);

// LNB
const lnbEl = $('.app-lnb');
const lnbAction = {
	init() {
		this.handler();
	},
	handler() {
		$window.on('scroll', (e) => this.scroll(e));
	},
	scroll(e) {
		let _this = $(e.currentTarget);
		let _st = _this.scrollTop();
		let referenceHeight = 0;
		const lnbEl = $('.app-lnb');
		const lnbWrapEl = lnbEl.find('.app-lnb__wrapper');
		const sectionEl = $('.section[data-section-name]');
		const referenceMessageEl = $('.reference-message');

		// referenceMessageEl 있을 경우 높이 계산
		if (referenceMessageEl) {
			referenceHeight = referenceMessageEl.outerHeight(true);
		}

		let sectionHeight = 0;
		let sectionMargin = 20 * (sectionEl.length - 1);

		sectionEl.each((i, v) => {
			sectionHeight += $(v).height();
		});
		sectionHeight += sectionMargin;

		let lnbBreak = sectionHeight - lnbWrapEl.outerHeight(true) + 64 - 300;
		if (_st >= lnbBreak) {
			lnbEl.addClass('app-lnb--break');
			lnbWrapEl.css('top', lnbBreak);
		} else {
			lnbEl.removeClass('app-lnb--break');
			lnbWrapEl.removeAttr('style');
		}
	},
};
if (lnbEl.length) lnbAction.init();

const positionTarget = {
	init(e) {
		this.set();
		this.dataSet(e);
	},
	set() {
		if ($('.position-target').length) return;
		$('body').append('<div class="position-target" style=""></div>');
	},
	dataSet(e) {
		$('.position-target').css('top', e);
	},
};

// Modal
const $modal = document.querySelectorAll('.modal[data-modal-name]');
const modalAction = {
	open: function (e, v) {
		bodyfixed('hidden');
		$modal.forEach((i) => {
			if (v == i.getAttribute('data-modal-name')) {
				i.classList.add('modal--open');
			} else {
				i.classList.remove('modal--close');
			}
		});

		if (v == 'modal-blood-pressure-gauge') {
			const _this = $(e.currentTarget);
			const _idx = _this.parent().index();

			if (
				_this.hasClass(
					'contents-button domestic-blood-pressure-gauge__button'
				)
			) {
				bloodPressureGaugeSwiper.slideTo(_idx, 0);
			} else {
				bloodPressureGaugeSwiper.slideTo(0, 0);
			}
		}
	},
	close: function () {
		const $modalVisible = $('.modal:visible');
		$modalVisible.removeClass('modal--open');
		bodyfixed('visible');
	},
	on($obj) {
		$obj.on('click', (e) => {
			const modalName = e.currentTarget.getAttribute('data-modal-name');
			this.open(e, modalName);
		});
	},
	off: function ($obj) {
		$obj.off('click');
	},
};
modalAction.on($('.modal-trigger-js'));

// Modal Close
$('.modal')
	.on('click', () => modalAction.close())
	.on('click', '.modal__close-button, .modal__close-button-js', () =>
		modalAction.close()
	)
	.on('click', '.modal__content-padding', (e) => e.stopPropagation());

// bodyfixed
function bodyfixed(e) {
	var $html = $('html');
	if (e == 'hidden') {
		$html.addClass('is-modal');
	} else if (e == 'visible') {
		$html.removeClass('is-modal');
	}
}

// Footer Floating
const appFooter = $('.app-footer');
const appFooterFloat = appFooter.find('.app-footer-float-wrapper');
const floatingTopButton = appFooterFloat.find('.app-footer-float__top-button');
const floatingAction = {
	init() {
		gsap.set(appFooterFloat, { alpha: 0 });
		appFooterFloat.addClass('is-invisible');
		this.handler();
	},
	handler() {
		floatingTopButton.on('click', () => this.click());
		$window.on('scroll', (e) => this.scroll(e));
	},
	click() {
		gsap.to('html, body', { scrollTop: 0 });
	},
	scroll(e) {
		const _this = $(e.currentTarget);
		const _windowHeight = $window.height();
		const appFooterFloat = $('.app-footer-float-wrapper__inner');
		const appFooterFloatBreak = appFooter.offset().top - $window.height();
		let _st = _this.scrollTop();

		if (_st >= _windowHeight / 3) {
			gsap.to('.app-footer-float-wrapper', { alpha: 1 });
			$('.app-footer-float-wrapper')
				.removeClass('is-invisible')
				.addClass('is-visible');
		} else {
			gsap.to('.app-footer-float-wrapper', { alpha: 0 });
			$('.app-footer-float-wrapper')
				.removeClass('is-visible')
				.addClass('is-invisible');
		}

		if (_st >= appFooterFloatBreak) {
			appFooterFloat.parent().addClass('app-footer-float-wrapper--break');
		} else {
			appFooterFloat
				.parent()
				.removeClass('app-footer-float-wrapper--break');
		}
	},
};
if (floatingTopButton.length) floatingAction.init();

// Section Active
const sectionData = $('[data-section-name]');
const lnbItem = $('.app-lnb__item');
const sectionAction = {
	init() {
		this.handler();
	},
	handler() {
		$window.on('scroll', (e) => this.scroll(e));
		lnbItem.on('click', '.app-lnb__button', (e) => this.click(e));
	},
	scroll(e) {
		const _header = $('.app-header');

		let _this = $(e.currentTarget);
		let _section = sectionData;
		let _length = _section.length;
		let _st = _this.scrollTop();
		let _gap = _header.outerHeight(true);

		lnbItem.removeClass('app-lnb__item--active');

		_section.each((i) => {
			if (i === _length - 1) {
				// Last
				if (_st >= _section.eq(_length - 1).offset().top - 20 - _gap) {
					lnbItem.removeClass('app-lnb__item--active');
					lnbItem.eq(_length - 1).addClass('app-lnb__item--active');
				}
			} else {
				if (
					_st >= _section.eq(i).offset().top - 20 - _gap &&
					_st <
						_section.eq(i).offset().top +
							20 +
							_section.eq(i).outerHeight(true) -
							_gap
				) {
					lnbItem.removeClass('app-lnb__item--active');
					lnbItem.eq(i).addClass('app-lnb__item--active');
				} else if (_st < _section.eq(0).offset().top - 20) {
					lnbItem.removeClass('app-lnb__item--active');
					lnbItem.eq(0).addClass('app-lnb__item--active');
				}
			}
		});
	},
	click(e) {
		const _this = $(e.currentTarget);
		let _idx = _this.parent().index();
		let _move = sectionData.eq(_idx).offset().top - 115 - 20;
		gsap.to('html, body', { scrollTop: _move });
	},
};
if (sectionData.length) sectionAction.init();

// Blood Pressure Gauge Swiper
const bloodPressureGauge = $('.blood-pressure-gauge-swiper--js');
let bloodPressureGaugeSwiper;
const bloodPressureGaugeSwiperAction = {
	init() {
		this.on();
	},
	on() {
		bloodPressureGaugeSwiper = new Swiper(bloodPressureGauge, {
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			speed: 400,
			observeParents: true,
			// observeSlideChildren: true,
			observer: true,
			navigation: {
				nextEl: '.blood-pressure-gauge__button-next',
				prevEl: '.blood-pressure-gauge__button-prev',
			},
		});
	},
};
if (bloodPressureGauge.length) bloodPressureGaugeSwiperAction.init();

// Motion
const $motion = $('.js-motion');
const motionAction = {
	init() {
		this.scroll();
		this.handler();
	},
	handler() {
		$window.on('scroll', () => this.scroll());
	},
	scroll() {
		if (!$motion.length) return;

		let _st = window.pageYOffset;

		$motion.each((i, v) => {
			const _this = $(v).offset().top;
			const wh = $window.outerHeight();

			if (_st >= _this - wh + $(v).outerHeight(true) / 2) {
				$(v).addClass('is-motion');
			} else {
				$(v).removeClass('is-motion');
			}
		});
	},
};
if ($motion.length) motionAction.init();
